// Feature flags read from the build environment (Vite). A flag is ON only when
// its variable is exactly 'true'; unset means off.
//
// Kept apart from the other constants on purpose: `import.meta` does not
// compile under the Jest/Babel setup, so modules imported by unit tests must
// not import this file.
const flag = (value) => String(value).trim().toLowerCase() === 'true';

export const FEATURE_FLAGS = Object.freeze({
  // ADR-199: Reports → Integrity Checks. Hidden until the check rules are
  // reviewed (CTO, 2026-11-03). Set VITE_INTEGRITY_CHECKS_REPORT_ENABLED=true
  // to show the tile, the route and the Scheduled Jobs link.
  INTEGRITY_CHECKS_REPORT: flag(import.meta.env.VITE_INTEGRITY_CHECKS_REPORT_ENABLED),
});
